import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "api/apiClient.ts";
interface Product {
  _id: string;
  name: { ar: string; en: string };
  price: number;
  description: { ar: string; en: string };
  quantity: number;
  category: {
    _id: string;
    name: { ar: string; en: string };
    state: "Available" | "Hidden" | "Test";
  };
  image?: string;
  state: "Available" | "Hidden" | "Test";
  isPack: boolean;
  packProduct?:
    | string
    | {
        _id: string;
        name: { ar: string; en: string };
        price: number;
        state: "Available" | "Hidden" | "Test";
      };
  packQuantity?: number;
  minSupplyQuantity: number;
  createdAt: string;
}
const fetchProducts = async (): Promise<Product[]> => {
  const { data } = await apiClient.get("/products", {});

  if (data.status !== "success" || !Array.isArray(data.data)) {
    throw new Error("Invalid response formDataat");
  }

  return data.data;
};
export const useProducts = () => {
  return useQuery({
    queryKey: ["products"],
    queryFn: fetchProducts,
  });
};

export const useRefetchProducts = () => {
  const queryClient = useQueryClient();

  return {
    refetch: async () => {
      await queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  };
};
export const useDeleteProduct = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/products/delete/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
};
export const useAddProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (product: Product) => {
      return await apiClient.post("/products/create", product);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
};
export const useUpdateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (product: Product) => {
      return await apiClient.patch(`/products/update/${product._id}`, product);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
};
